const state = () => ({
  notifications: [],
});

const getters = {
  notifications: state => [...state.notifications],
};

const actions = {
  async setNotifications({ commit }, notifications) {
    commit('SET_NOTIFICATIONS', notifications);
  },
  async addNotification({ commit }, notification) {
    commit('ADD_NOTIFICATION', notification);
  },
  async removeNotification({ commit }, id) {
    commit('REMOVE_NOTIFICATION', id);
  },
};

const mutations = {
  SET_NOTIFICATIONS(state, value) {
    state.notifications = value;
  },
  ADD_NOTIFICATION(state, value) {
    state.notifications.unshift(value);
  },
  REMOVE_NOTIFICATION(state, id) {
    const index = state.notifications.findIndex(notification => notification.id === id);

    if (index > -1) {
      state.notifications.splice(index, 1);
    }

    console.log(state.notifications);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
